import { useI18n } from "vue-i18n";

const SHARED = "page.integration.numbers_table.connected_numbers";
const OWN = "tiktok.table.statuses";

/**
 * The status list is shared with the messenger tables, where a few entries are
 * worded for a number. Those are overridden under tiktok.table.statuses;
 * everything else falls back to the shared wording.
 */
export default function useAccountStatusLabel() {
    const { t, te } = useI18n();

    const statusLabel = (key) => {
        if (!key) return "";

        const ownKey = `${OWN}.${key}`;
        return te(ownKey) ? t(ownKey) : t(`${SHARED}.${key}`);
    };

    return { statusLabel };
}
